import PoolBasics from './create_type'
import { connect } from 'react-redux'
import { formatMoney } from 'client/griffin'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { CROWDFUNDING_GOAL_AMOUNT } from 'shared/shared_consts'

const { MAX_AMOUNT } = CROWDFUNDING_GOAL_AMOUNT

const mapStateToProps = (state, props) => {
  const isBusinessAccount = state.flags.is_business_account
  const campaign = getCampaignSelector(state, props)
  const formattedMaxGoalAmount = formatMoney(campaign.currency, MAX_AMOUNT, {
    removeTrailingZeros: true,
  })

  return {
    formattedMaxGoalAmount,
    isBusinessAccount,
  }
}

export default connect(mapStateToProps)(PoolBasics)
